import React from "react";
import ApplicantMessagingWorkspace from "../components/applicant/ApplicantMessagingWorkspace";

export default function ApplicantFilingRequests() {
  return <ApplicantMessagingWorkspace focusMode="documents" />;
}
